/**
 * @description 阿里oss直传
 * @author yuming
 * @date "2021-05-10"
 *
 * 介绍 vue mixin方法，详情参考：https://cn.vuejs.org/v2/guide/mixins.html
 * 钩子函数会按（此文件-引用文件）的顺序依次执行
 *
 * @example
 *      import ossign_mixin from '@/common/mixin_ossign.js';
 *      export default {
            mixins: [ossisn_mixin],
            methods:{
                imgOssign() {
                    // 直接调用方法即可
                    this.getOssign();
                }
            }
        }
 */

// 定义一个混合对象
import Compressor from 'compressorjs';
export default {
    data() {
        return {
            action:'',
            multipart_params: {
                key: '',
                policy: '',
                OSSAccessKeyId: '',
                success_action_status: '200', //让服务端返回200,不然，默认会返回204
                //callback: '', //不要回调
                signature: ''
            }
        }
    },
    methods: {
        // 获取文件扩展名
        getSuffix (filename) {
            var pos = (filename||'').lastIndexOf('.');
            var suffix = '';
            if (pos != -1) {
                suffix = filename.substring(pos);
            }
            return suffix;
        },
        compressImg(file){
            return new Promise((resolve,reject) => {
                 // compressorjs 默认开启 checkOrientation 选项
                 // 会将图片修正为正确方向
                 new Compressor(file, {
                     maxWidth:2048,
                     success: function(result){
                        var file = new File([result], result.name, {
                            type: result.type,
                          });
                         resolve(file);
                    },
                     error(err){
                         reject(err);
                     },
                 });
             });
         },
        uploadImg(file,params){//文件上传
            return new Promise((resolve,reject)=>{
                this.getOssign(file,params).then(()=>{
                    //获取到上传地址之后把文件上传到这里
                    var formData = new FormData();
                    for (let key in this.multipart_params) {
                        formData.append(key, this.multipart_params[key])
                      }
                      // append 文件必须放在最后，不然会报key错误
                    formData.append("file", file.file);
                    this.$axios.post(this.action,formData,{handleErrorsYourself:params.handleErrorsYourself||false},{
                        headers:{
                            'Content-Type':'multipart/form-data'
                        },
                    }).then(()=>{
                        resolve();
                    }).catch(function(){
                        reject();
                    })
                }).catch(function(){
                    reject();
                })
            });
            
        },
        // 获取签名
        getOssign(file, args) {
            return new Promise((resolve, reject) => {
                this.$axios.post('/foundation/common/file/ossUploadSign',
                    {
                        scheme: location.protocol,
                        remote: location.host,
                        fileName: Math.random().toString(36).substring(2, 8)+'-'+file.file.name||'',
                        fileExt: this.getSuffix(file.file.name),
                        bizType: args.secondDir,
                        osskeyFirstDir: args.firstDir,
                        osskeySecondDir: args.secondDir,
                        owerId: args.owerId,
                    },
                   { handleErrorsYourself:args.handleErrorsYourself||false}
                ).then((res)=>{
                    if (res.statusCode == '0') {
                        file.osskey = res.data['key'];
                        this.action = res.data.host;
                        this.multipart_params = {
                            key: res.data['key'],
                            policy: res.data['policy'],
                            OSSAccessKeyId: res.data['ossAccessKeyId'], 
                            success_action_status: '200',
                            signature: res.data['signature']
                        };
                        resolve();
                    } else {
                        reject();
                    }
                }).catch(err => {
                    reject(err);
                });
            });
        },
        //上传到企业微信
        uploadToWeWork(file){//文件上传到企业微信
            return new Promise((resolve,reject)=>{
                var formData = new FormData();
                // append 文件必须放在最后，不然会报key错误
                formData.append("jpgFile", file.file);
                this.$axios.post('/foundation/wx/uploadJpg',formData,{
                    headers:{
                        'Content-Type':'multipart/form-data'
                    }
                }).then((res)=>{
                    if(res.statusDesc){
                        resolve(res.statusDesc);
                    }else{
                        //this.$alert('上传到企业微信失败,请重新上传');
                        this.$dialog.alert({
                            message: '上传到企业微信失败,请重新上传'
                        });
                        reject();
                    }
                })
            })
        },
        base64ToFile(dataurl, filename){//base64转文件
            var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
    }
}
